
import { dateFormat } from "@/types/dateFormat";
import { defineComponent } from "vue";
export default defineComponent({
  computed: {
    isRegistrationOpen() {
      return this.$store.getters["edition/isRegistrationOpen"];
    },
    registrationStartDate() {
      return this.$store.getters[
        "edition/getRegistrationStartDate"
      ].toLocaleDateString("FR-fr", dateFormat);
    },
    registrationEndDate() {
      return this.$store.getters[
        "edition/getRegistrationEndDate"
      ].toLocaleDateString("FR-fr", dateFormat);
    },
  },
  methods: {
    register() {
      this.$router.push({ name: "Register" });
    },
    login() {
      this.$router.push({ name: "Login" });
    },
  },
});
